module.exports = __webpack_public_path__ + "static/media/crew_ai_logo.359269f1.png";